import { create } from 'zustand';
import { PhotoDisplayData } from '../types/PhotoDisplayData';
import { Event, SeasonContext } from '../types';

interface AdminState {
  isAdminMode: boolean;
  showUploadModal: boolean;
  selectedEventForUpload: string | null;

  // Photo actions modal state
  showPhotoActionsModal: boolean;
  selectedPhotoForActions: PhotoDisplayData | null;
  selectedPhotoIndex: number;
  selectedPhotoTotalCount: number;
  isEditingCaption: boolean;

  // Season create modal state
  showSeasonCreateModal: boolean;

  // Season actions modal state
  showSeasonActionsModal: boolean;
  selectedSeasonForActions: SeasonContext | null;

  // Event create modal state
  showEventCreateModal: boolean;
  selectedSeasonContext: SeasonContext | null;

  // Event actions modal state
  showEventActionsModal: boolean;
  selectedEvent: Event | null;

  // Actions
  toggleAdminMode: () => void;
  openUploadModal: (eventName: string) => void;
  closeUploadModal: () => void;
  openPhotoActionsModal: (
    photo: PhotoDisplayData,
    index: number,
    totalCount: number
  ) => void;
  closePhotoActionsModal: () => void;
  startCaptionEdit: () => void;
  stopCaptionEdit: () => void;

  // Season create actions
  openSeasonCreateModal: () => void;
  closeSeasonCreateModal: () => void;

  // Season actions
  openSeasonActionsModal: (seasonContext: SeasonContext) => void;
  closeSeasonActionsModal: () => void;

  // Event create actions
  openEventCreateModal: (seasonContext: SeasonContext) => void;
  closeEventCreateModal: () => void;

  // Event actions
  openEventActionsModal: (event: Event) => void;
  closeEventActionsModal: () => void;
}

export const useAdminStore = create<AdminState>((set) => ({
  isAdminMode: false,
  showUploadModal: false,
  selectedEventForUpload: null,

  // Photo actions modal state
  showPhotoActionsModal: false,
  selectedPhotoForActions: null,
  selectedPhotoIndex: 0,
  selectedPhotoTotalCount: 0,
  isEditingCaption: false,

  // Season create modal state
  showSeasonCreateModal: false,

  // Season actions modal state
  showSeasonActionsModal: false,
  selectedSeasonForActions: null,

  // Event create modal state
  showEventCreateModal: false,
  selectedSeasonContext: null,

  // Event actions modal state
  showEventActionsModal: false,
  selectedEvent: null,

  toggleAdminMode: () => set((state) => ({ isAdminMode: !state.isAdminMode })),
  
  openUploadModal: (eventName: string) => set({
    showUploadModal: true,
    selectedEventForUpload: eventName
  }),

  closeUploadModal: () => set({
    showUploadModal: false,
    selectedEventForUpload: null
  }),

  openPhotoActionsModal: (photo, index, totalCount) => set({
    showPhotoActionsModal: true,
    selectedPhotoForActions: photo,
    selectedPhotoIndex: index,
    selectedPhotoTotalCount: totalCount,
    isEditingCaption: false
  }),

  closePhotoActionsModal: () => set({
    showPhotoActionsModal: false,
    selectedPhotoForActions: null,
    selectedPhotoIndex: 0,
    selectedPhotoTotalCount: 0,
    isEditingCaption: false
  }),

  startCaptionEdit: () => set({ isEditingCaption: true }),
  stopCaptionEdit: () => set({ isEditingCaption: false }),

  // Season create actions
  openSeasonCreateModal: () => set({ showSeasonCreateModal: true }),
  closeSeasonCreateModal: () => set({ showSeasonCreateModal: false }),

  // Season actions
  openSeasonActionsModal: (seasonContext: SeasonContext) => set({
    showSeasonActionsModal: true,
    selectedSeasonForActions: seasonContext
  }),
  closeSeasonActionsModal: () => set({
    showSeasonActionsModal: false,
    selectedSeasonForActions: null
  }),

  // Event create actions
  openEventCreateModal: (seasonContext: SeasonContext) => set({
    showEventCreateModal: true,
    selectedSeasonContext: seasonContext
  }),
  closeEventCreateModal: () => set({
    showEventCreateModal: false,
    selectedSeasonContext: null
  }),

  // Event actions
  openEventActionsModal: (event: Event) => set({
    showEventActionsModal: true,
    selectedEvent: event
  }),
  closeEventActionsModal: () => set({
    showEventActionsModal: false,
    selectedEvent: null
  }),
}));;
